import "photoswipe/style.css";
import PhotoSwipeLightbox from "photoswipe/lightbox";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll<HTMLElement>(".component__media.media--image .swiper").forEach((swiperEl) => {
    const lightbox = new PhotoSwipeLightbox({
      gallery: swiperEl,
      children: ".swiper-slide:not(.swiper-slide-duplicate) a",
      showHideAnimationType: "fade",
      pswpModule: () => import("photoswipe"),
    });
    lightbox.init();
  });

  document.querySelectorAll<HTMLElement>(".component__gallery .gallery__grid").forEach((galleryEl) => {
    const lightbox = new PhotoSwipeLightbox({
      gallery: galleryEl,
      children: "a.gallery__item",
      showHideAnimationType: "fade",
      pswpModule: () => import("photoswipe"),
    });
    lightbox.init();
  });
});
